<script setup lang="ts">
import StatusOverlay from '../StatusOverlay.vue'
</script>

<template>
  <StatusOverlay
    class="text-neutral-light-10 pointer-events-none"
    data-testid="event-status-overlay"
  >
    <slot />
  </StatusOverlay>
</template>
